import { __rest } from "tslib";
import classNames from 'classnames';
import { createElement } from 'rax';
import View from '../../view';
const ListItemContent = (props) => {
    const { prefix = 'mt-', className } = props, others = __rest(props, ["prefix", "className"]);
    return <View className={classNames(`${prefix}list-item-content`, className)} {...others}/>;
};
export default ListItemContent;
